module.exports = __webpack_public_path__ + "img/矩形（8）.09971319.png";